import { Skeleton } from "@/modern/components/ui/skeleton";

const SettingLoadingSkeleton = () => {
  return (
    <div className="flex h-full w-full">
      {/* Left Panel - Categories Sidebar Skeleton */}
      <div className="w-64 border-r border-border flex flex-col bg-background">
        {/* Header Skeleton */}
        <div className="sticky top-0 z-10 px-5 h-[60px] flex items-center justify-between border-b border-border bg-background">
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-8 w-8 rounded-md" />
        </div>

        {/* Categories List Skeleton */}
        <div className="flex-1 overflow-y-auto p-3 space-y-1">
          {/* Regular Categories */}
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
            <div key={`cat-${i}`} className="px-3 py-2 flex items-center gap-3 rounded-lg">
              <Skeleton className="h-4 w-4 rounded" />
              <Skeleton className="h-4 flex-1" />
            </div>
          ))}
        </div>
      </div>

      {/* Main Content Area Skeleton */}
      <div className="flex-1 min-w-0 overflow-y-auto">
        <div className="p-6 space-y-6">
          {/* Header Section */}
          <div className="mb-6 pb-6 px-6 -mx-6 border-b">
            <Skeleton className="h-8 w-64 mb-2" />
            <Skeleton className="h-4 w-96" />
          </div>

          {/* Content Cards */}
          <div className="space-y-5 max-w-3xl">
            {/* Card 1 - Large */}
            <div className="p-6 rounded-lg border border-border bg-card">
              <div className="space-y-4">
                <div className="flex items-start justify-between">
                  <div className="space-y-2 flex-1">
                    <Skeleton className="h-5 w-48" />
                    <Skeleton className="h-4 w-full max-w-md" />
                  </div>
                  <Skeleton className="h-9 w-24 rounded-md" />
                </div>
                <div className="space-y-3 pt-4">
                  <Skeleton className="h-10 w-full rounded-md" />
                  <Skeleton className="h-10 w-full rounded-md" />
                  <Skeleton className="h-10 w-full rounded-md" />
                </div>
              </div>
            </div>

            {/* Card 2 - Medium */}
            <div className="p-6 rounded-lg border border-border bg-card">
              <div className="space-y-4">
                <div className="space-y-2">
                  <Skeleton className="h-5 w-40" />
                  <Skeleton className="h-4 w-full max-w-lg" />
                </div>
                <div className="space-y-2">
                  <Skeleton className="h-10 w-full rounded-md" />
                  <Skeleton className="h-20 w-full rounded-md" />
                </div>
              </div>
            </div>

            {/* Card 3 - Small */}
            <div className="p-6 rounded-lg border border-border bg-card">
              <div className="space-y-3">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-4 w-full max-w-sm" />
                <Skeleton className="h-10 w-32 rounded-md" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingLoadingSkeleton;
